import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { IconPipe } from '../../../../pipes/icon/icon';
import { EventDetailsModel, RouteModel } from '../../../../providers/event/event';
import { GoogleMapsProvider } from '../../../../providers/google-maps/google-maps';

@Component({
  selector: 'page-event-details-map',
  templateUrl: 'event-details-map.html',
})
export class EventDetailsMapPage {

  event: EventDetailsModel;
  route: RouteModel;
  constructor(public navCtrl: NavController, public navParams: NavParams, private googleService: GoogleMapsProvider, private icons: IconPipe) {
    //{ event: this.event, route: model }
    this.event = navParams.data.event;
    this.route = navParams.data.route;
  }

  ionViewDidLoad() {

  }


  loaded(map) {
    this.googleService.getGoogle().then(async (google) => {
      let decodedPath = [];
      if (this.route && this.route.routeInfos) {
        this.route.routeInfos.forEach((item) => {
          decodedPath = decodedPath.concat(google.maps.geometry.encoding.decodePath(item.path));
        });
      }
      let startPos = null;
      let endPos = null;
      if (decodedPath.length > 0) {
        new google.maps.Polyline({
          path: decodedPath,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#0000AA',
          fillOpacity: 0.35,
          map: map
        });
        startPos = decodedPath[0];
        if (decodedPath.length > 1) {
          endPos = decodedPath[decodedPath.length - 1];
        }
      } else {
        startPos = this.event;
        decodedPath.push(this.event);
      }
      if (startPos !== null) {
        new google.maps.Marker({
          position: startPos,
          map: map,
          icon: await this.icons.transform(this.event.cid + "", "marker")
        });
      }
      if (endPos) {
        new google.maps.Marker({
          position: endPos,
          map: map,
          icon: this.icons.get("marker", "finish")
        });
      }
      var bounds = new google.maps.LatLngBounds();
      decodedPath.forEach((item) => {
        bounds.extend(item);
      })
      map.fitBounds(bounds);
    });
  }

}



// WEBPACK FOOTER //
// /src/pages/event/details/event-details-map/event-details-map.ts